import { render, staticRenderFns } from "./QTableWithPagination.vue?vue&type=template&id=f5c675e2&scoped=true"
import script from "./QTableWithPagination.vue?vue&type=script&lang=js"
export * from "./QTableWithPagination.vue?vue&type=script&lang=js"
import style0 from "./QTableWithPagination.vue?vue&type=style&index=0&id=f5c675e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c675e2",
  null
  
)

export default component.exports